var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33385 8.99861L9.19585 8.99861L7.56985 10.6246C7.38225 10.8121 7.27683 11.0665 7.27677 11.3317C7.2767 11.5969 7.38201 11.8513 7.56952 12.0389C7.75703 12.2265 8.01138 12.332 8.27661 12.332C8.54185 12.3321 8.79625 12.2268 8.98385 12.0393L11.3745 9.64861C11.8113 9.21059 12.0566 8.61722 12.0566 7.99861C12.0566 7.38 11.8113 6.78664 11.3745 6.34861L8.98385 3.95795C8.79625 3.77044 8.54185 3.66513 8.27662 3.6652C8.01138 3.66526 7.75703 3.77068 7.56952 3.95828C7.38201 4.14588 7.2767 4.40028 7.27677 4.66552C7.27683 4.93075 7.38225 5.18511 7.56985 5.37261L9.19585 6.99861L3.33385 6.99861C3.06863 6.99861 2.81428 7.10397 2.62674 7.29151C2.43921 7.47904 2.33385 7.7334 2.33385 7.99861C2.33385 8.26383 2.43921 8.51818 2.62674 8.70572C2.81428 8.89326 3.06863 8.99861 3.33385 8.99861Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSm);
export default __webpack_public_path__ + "static/media/arrow-right-sm.13c9d516460a1bf312f254061f70ef4f.svg";
export { ForwardRef as ReactComponent };